import { useAppDispatch } from "@/store";
import BaseModal from "../common/HPBaseModal";
import { ModalProps } from "@_constants/modal";
import { t } from "@utils/i18n";
import React from "react";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface UnpublishDashboardModalProps extends ModalProps {
  action: () => void;
  sharedUsersCount: number;
}

const UnpublishDashboardModal: React.FC<UnpublishDashboardModalProps> = ({
  action,
  sharedUsersCount,
  cancelAction,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  const message =
    sharedUsersCount > 0
      ? t("modals.unpublishDashboard.message", {
          count: sharedUsersCount,
        })
      : t("modals.unpublishDashboard.messageNoUsers");

  return (
    <BaseModal
      title={t("modals.unpublishDashboard.title")}
      message={message}
      onConfirm={action}
      onCancel={closeTopModal}
      confirmButtonText={t("modals.unpublishDashboard.confirmButton")}
      cancelButtonText={t("common.cancel")}
    />
  );
};

export default UnpublishDashboardModal;
